// Tenantra Inc. - Keep a filter in sync with the URL query string
import { useEffect, useState } from 'react';
import { NAV_EVENT } from './navigation';

const readParam = (key, fallback) => new URLSearchParams(window.location.search).get(key) || fallback;

const useNavListener = (fn) => {
  useEffect(() => {
    window.addEventListener(NAV_EVENT, fn);
    window.addEventListener('popstate', fn);
    return () => { window.removeEventListener(NAV_EVENT, fn); window.removeEventListener('popstate', fn); };
  }, []); // eslint-disable-line
};

export const useLocationSearch = () => {
  const [search, setSearch] = useState(window.location.search);
  useNavListener(() => setSearch(window.location.search));
  return search;
};

export const useUrlParam = (key, fallback = 'all') => {
  const [value, setValue] = useState(() => readParam(key, fallback));
  useNavListener(() => setValue(readParam(key, fallback)));
  const update = (next) => {
    const url = new URL(window.location.href);
    if (next === fallback) url.searchParams.delete(key); else url.searchParams.set(key, next);
    window.history.replaceState({}, '', url.pathname + url.search);
    window.dispatchEvent(new Event(NAV_EVENT));
  };
  return [value, update];
};
